import React, { useRef } from 'react'
import './Leadership.css';

import chloe from './images/Leadership/2026-2027/chloe.jpg';
import jessia from './images/Leadership/2026-2027/jessia.jpeg';
import nancy from './images/Leadership/2026-2027/nancy.jpeg';
import logo from './logo.png';

import {BsFacebook, BsDiscord} from 'react-icons/bs'
import {RiInstagramFill} from 'react-icons/ri'

const Leadership = () => {
  const ref = useRef(null);
  return (
    <><div>
      <div>
        <br></br>
        <br></br>
        <div>
          <div className='teamTitle-wrapper'>
            <p id="teamTitle">Officers 2026 - 2027</p>
          </div>
        </div>
        <div class="members">

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={jessia} alt="Jessia Huang" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Jessia Huang</b>
              </h4>
              <p class='role'>Chair</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={logo} alt="Prakshi Shukla" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Prakshi Shukla</b>
              </h4>
              <p class='role'>Vice Chair</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={chloe} alt="Chloe Bogen"/>
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Chloe Bogen</b>
              </h4>
              <p class='role'>Social Events Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={logo} alt="Ioli Shrivastava" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Ioli Shrivastava</b>
              </h4>
              <p class='role'>Social Media Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={logo} alt="Ahana Mangla" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Ahana Mangla</b>
              </h4>
              <p class='role'>Public Relations Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={logo} alt="Priyanka Mungra" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Priyanka Mungra</b>
              </h4>
              <p class='role'>Community Relations Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

          <div class="member-wrapper">
            <div class="img-background">
              <img class="memberImage" src={nancy} alt="Nancy Kim" />
            </div>
            <div class="teamInfo">
              <h4 class="teamName">
                <b>Nancy Kim</b>
              </h4>
              <p class='role'>Student Resources Director</p>
              <p>She/Her/Hers</p>
            </div>
          </div>

        </div>

      </div>
    </div>
    <div className='actions' ref={ref}>
    <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' rel="noreferrer" className='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank' rel="noreferrer" className='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' aria-label="Instagram" target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' aria-label="Facebook" target='_blank' rel="noreferrer"><BsFacebook/></a>
          <a id='discord' href='https://discord.gg/Zp4GVB7ddq' aria-label="Discord" target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" className='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
    </div></>
  )
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Leadership;
